import logoTechMode from '../../../assets/images/logos/tech-mode-mobile.png';
import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useEffect, useState } from 'react';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const API_KEY_MAP = process.env.REACT_APP_OPENROUTESERVICE_API_KEY; // Reemplaza con tu clave API de HERE

const techModeMarker = L.icon({
    iconUrl: './assets/icons/marker-green.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [0, -41],
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const userMarker = L.icon({
    iconUrl: './assets/icons/marker-red.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

export function MapComponent({ userLocation, data }) {

    const [routeCoordinates, setRouteCoordinates] = useState([]);
    const [startLocation, setStartLocation] = useState(null);
    const [companyCoords, setCompanyCoords] = useState(null);

    useEffect(() => {
        if (userLocation) setStartLocation(userLocation);
    }, [userLocation]);

    useEffect(() => {
        if (data.companyCoords) setCompanyCoords(data.companyCoords);
    }, [data]);

    useEffect(() => {
        const fetchRoute = async () => {

            if (!startLocation) return;

            try {
                const url = 'https://api.openrouteservice.org/v2/directions/driving-car/json';
                const body = JSON.stringify({
                    coordinates: [
                        [startLocation[1], startLocation[0]], // Coordenadas de origen
                        [companyCoords[1], companyCoords[0]] // Coordenadas de destino
                    ]
                });

                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json, application/geo+json, application/gpx+xml, img/png; charset=utf-8',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${API_KEY_MAP}`
                    },
                    body: body
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                const routeCoords = decodePolyline(data.routes[0].geometry);
                setRouteCoordinates(routeCoords);

            } catch (error) {
                console.error('Error al obtener la ruta:', error);
            }
        };

        fetchRoute();
    }, [startLocation, companyCoords]);

    const decodePolyline = (encoded) => {
        let index = 0;
        let lat = 0;
        let lon = 0;
        let coordinates = [];

        while (index < encoded.length) {
            let result = 0;
            let shift = 0;
            let byte;
            do {
                byte = encoded.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
            } while (byte >= 0x20);

            const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
            lat += deltaLat;

            result = 0;
            shift = 0;
            do {
                byte = encoded.charCodeAt(index++) - 63;
                result |= (byte & 0x1f) << shift;
                shift += 5;
            } while (byte >= 0x20);

            const deltaLon = (result & 1) ? ~(result >> 1) : (result >> 1);
            lon += deltaLon;

            coordinates.push([lat / 1e5, lon / 1e5]);
        }

        return coordinates;
    };


    return (
        <MapContainer
            className='map-container w-100'
            center={[-7.173253, -78.511372]}
            zoom={14}
        >
            <TileLayer
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            />
            {
                userLocation && (
                    <Marker position={userLocation} icon={userMarker}></Marker>
                )
            }
            {/* <Marker position={[-7.173253, -78.511372]} icon={techModeMarker}> */}
            <Marker position={data.companyCoords} icon={techModeMarker}>
                <Popup>
                    <div className='popup-map d-flex align-items-center'>
                        <img className='popup-map__img' src={logoTechMode} alt='Logo de marca' />
                        <div className='popup-map__text d-flex flex-column justify-content-center'>
                            <p className='popup-map__title text-center mt-0 mb-1'>{data.companyName}</p>
                            <p className='popup-map__description m-0'>{data.companyAddress}</p>
                        </div>
                    </div>
                </Popup>
            </Marker>
            {
                userLocation !== null && routeCoordinates.length > 0 && (
                    <Polyline positions={routeCoordinates} color='red' />
                )
            }
        </MapContainer>
    );
}